angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsHomeCtrl", [
  "$scope", "$state", "progress", "HelperService", "CustomerApplicationService", "ConfigService", "ApplicationService", "$controller",
  ($scope, $state, progress, HelperService, CustomerApplicationService, ConfigService, ApplicationService, $controller) ->

    $scope.page = "home"

    if explicitStage = HelperService.getQueryStringParameter('navigate')
      CustomerApplicationService.goToStage explicitStage
    else
      if _.last(ApplicationService.viewable_pages)
        CustomerApplicationService.goToStage(_.last(ApplicationService.viewable_pages))
      else
        $state.go 'service_failure'

]
